export default __webpack_public_path__ + "static/media/Ostali 12.03c5bd65.jpg";